import type { ChainModifiers, Entry, EntryFieldTypes, EntrySkeletonType, LocaleCode } from 'contentful'

export interface TypePrintablesLibraryBookFields {
  title: EntryFieldTypes.Symbol
  role: EntryFieldTypes.Symbol<'Student' | 'Teacher'>
  bookCover: EntryFieldTypes.AssetLink
  singleSidedPdf?: EntryFieldTypes.AssetLink
  doubleSidedPdf?: EntryFieldTypes.AssetLink
  miniBookPdf?: EntryFieldTypes.AssetLink
  colourPdf?: EntryFieldTypes.AssetLink
  blackAndWhitePdf?: EntryFieldTypes.AssetLink
  singleBwPdf?: EntryFieldTypes.AssetLink
  doubleBwPdf?: EntryFieldTypes.AssetLink
  miniBookBwPdf?: EntryFieldTypes.AssetLink
}

export type TypePrintablesLibraryBookSkeleton = EntrySkeletonType<
  TypePrintablesLibraryBookFields,
  'printablesLibraryBook'
>
export type TypePrintablesLibraryBook<
  Modifiers extends ChainModifiers,
  Locales extends LocaleCode = LocaleCode,
> = Entry<TypePrintablesLibraryBookSkeleton, Modifiers, Locales>

export function isTypePrintablesLibraryBook<Modifiers extends ChainModifiers, Locales extends LocaleCode>(
  entry: Entry<EntrySkeletonType, Modifiers, Locales>,
): entry is TypePrintablesLibraryBook<Modifiers, Locales> {
  return entry.sys.contentType.sys.id === 'printablesLibraryBook'
}

export type TypePrintablesLibraryBookWithoutLinkResolutionResponse =
  TypePrintablesLibraryBook<'WITHOUT_LINK_RESOLUTION'>
export type TypePrintablesLibraryBookWithoutUnresolvableLinksResponse =
  TypePrintablesLibraryBook<'WITHOUT_UNRESOLVABLE_LINKS'>
export type TypePrintablesLibraryBookWithAllLocalesResponse<Locales extends LocaleCode = LocaleCode> =
  TypePrintablesLibraryBook<'WITH_ALL_LOCALES', Locales>
export type TypePrintablesLibraryBookWithAllLocalesAndWithoutLinkResolutionResponse<
  Locales extends LocaleCode = LocaleCode,
> = TypePrintablesLibraryBook<'WITHOUT_LINK_RESOLUTION' | 'WITH_ALL_LOCALES', Locales>
export type TypePrintablesLibraryBookWithAllLocalesAndWithoutUnresolvableLinksResponse<
  Locales extends LocaleCode = LocaleCode,
> = TypePrintablesLibraryBook<'WITHOUT_UNRESOLVABLE_LINKS' | 'WITH_ALL_LOCALES', Locales>
